import { Alert, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { QuotationAccount } from '@/features/operations/types';

/**
 * Right after a counter quotation (#229, U-2 of #107): which account it went to and whether
 * registering it created that account and sent the invitation, so whoever is attending can
 * tell the person to look for the mail.
 */
export function CounterAccountNotice({
  account,
  invitationSent,
}: {
  account: QuotationAccount | null | undefined;
  invitationSent: boolean;
}) {
  if (!account) {
    return null;
  }

  const sheet = (
    <Link component={RouterLink} to={`/admin/customers/${account.id}`}>
      Ver la ficha del cliente
    </Link>
  );

  return (
    <Alert severity="info">
      <Typography variant="subtitle2" gutterBottom>
        Quedó en la cuenta de {account.fullName} · {account.email}
      </Typography>
      <Typography variant="body2">
        {invitationSent
          ? `Es una cuenta nueva: le mandamos a ${account.email} la invitación para activarla. Avisale que la busque, también en spam. `
          : account.status === 'PENDING'
            ? 'Ya tenía una cuenta, todavía pendiente de activar: si no le llegó la invitación, reenviala desde su ficha. '
            : 'Ya tenía una cuenta activa, así que no le mandamos nada nuevo. '}
        {sheet}
      </Typography>
    </Alert>
  );
}
